import { useTranslation } from "react-i18next";
import { GroupStandings } from "../../../models/MatchViews";
import MatchplayGroupStandings from "../dashboard/MatchplayGroupStandings";
import { CollapsibleSection } from "../../utils/CollapsibleSection";

interface Props {
    standings: GroupStandings[];
    collapsed?: boolean;
    showTies?: boolean;
}

const MatchplayGroupGameAdministration = ({ standings, collapsed, showTies }: Props) => {
    const { t } = useTranslation();

    return (
        <CollapsibleSection
            title={t('components.matchplay.common.groupPhase')}
            showCollapseAction={true}
            collapsed={collapsed}>
            <MatchplayGroupStandings standings={standings} highlightTies={showTies}/>
        </CollapsibleSection>
    );
};

export default MatchplayGroupGameAdministration;
